import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { GiftcardsAddToBasketComponentDef } from '@df/module-giftcards/giftcards-add-to-basket.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/api/result.component';

@Component({
    selector: 'giftcards-add-to-basket',
    templateUrl: './giftcards-add-to-basket.html',
    standalone: true,
    imports: [ActionComponent, CommonModule, ResultComponent, TranslatePipe]
})
export class GiftcardsAddToBasketComponent extends GiftcardsAddToBasketComponentDef {
    /**
     * Disable button
     */
    @Input()
    disabled?: boolean;
}
